module.exports = __webpack_public_path__ + "media/identify/icon_fixed-61535541.svg";